var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 53",
    x: 1.21924,
    width: 25,
    height: 1.72414,
    transform: "rotate(45 1.21924 0)",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 54",
    x: 0.219238,
    y: 18,
    width: 25,
    height: 1.72414,
    transform: "rotate(-45 0.219238 18)",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.dcc49c3ba8d51c1bb6320c1ace455d72.svg";
export { ForwardRef as ReactComponent };